if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}
Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  };
};
Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};
Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent("on" + eventName, callback);
};
Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};
  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);
  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};
Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options["hideElement"] || province_domid);
  Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));
  this.initCountry();
  this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },
  initProvince: function() {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },
  countryHandler: function(e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);
    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }
      this.provinceContainer.style.display = "";
    }
  },
  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },
  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  let value = "";
  let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  let formatString = format || this.moneyFormat;
  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), cents2 = parts[1] ? decimal + parts[1] : "";
    return dollars + cents2;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ", ",");
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ",");
      break;
    case "amount_with_period_and_space_separator ":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
  }
  return formatString.replace(placeholderRegex, value);
};
window.window.ON_CHANGE_DEBOUNCE_TIMER = 300;
window.window.PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  variantChange: "variant-change",
  cartError: "cart-error",
  wishlistUpdate: "wishlist-update",
  infiniteLoadFinished: "infinite-load-finished",
  listRenderCompleted: "list-render-completed"
};
window.WISHLIST_PARAMS = {
  key: "__sm_wishlist_data"
};
window.VARIANT_PILLS_PALETTE = (() => {
  let pillsPaletteSplit = [];
  if (window.Shopify.variantPillsPalette) {
    pillsPaletteSplit = window.Shopify.variantPillsPalette.split(",");
  }
  const pillsPaletteColors = {};
  for (let item of pillsPaletteSplit) {
    let key = item.split(":")[0] || "";
    let value = item.split(":")[1] || "";
    pillsPaletteColors[key.replace(/\s+/g, "").toLowerCase()] = value.replace(/\s+/g, "");
  }
  return pillsPaletteColors;
})();
window.debounce = function(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
};
window.fetchConfig = function(type = "json") {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: `application/${type}` }
  };
};
window.fetchData = async function(url, instanceMethod = "json") {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}, URL: ${url}`);
    }
    return await response[instanceMethod]();
  } catch (error) {
    console.error(`Failed to fetch ${url}:`, error);
    return { error: error.message, url };
  }
};
window.fetchWithConcurrencyLimit = async function(urls, instanceMethod, concurrencyLimit = 6) {
  const results = new Array(urls.length);
  const executing = /* @__PURE__ */ new Set();
  const addTask = async (url, index) => {
    const task = window.fetchData(url, instanceMethod).then((result) => {
      results[index] = result;
    }).finally(() => {
      executing.delete(task);
    });
    executing.add(task);
    if (executing.size >= concurrencyLimit) {
      await Promise.race(executing);
    }
  };
  for (let i = 0; i < urls.length; i++) {
    await addTask(urls[i], i);
  }
  await Promise.all(executing);
  return results;
};
window.subscribers = {};
window.subscribe = function(eventName, callback) {
  if (subscribers[eventName] === void 0) {
    subscribers[eventName] = [];
  }
  subscribers[eventName] = [...subscribers[eventName], callback];
  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
};
window.publish = function(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
};
window.getFocusableElements = function(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
};
window.pauseAllMedia = function() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI)
      model.modelViewerUI.pause();
  });
};
window.removeTrapFocus = function(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);
  if (elementToFocus)
    elementToFocus.focus();
};
window.trapFocusHandlers = {};
window.trapFocus = function(container, elementToFocus = container) {
  var elements = window.getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];
  window.removeTrapFocus();
  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first)
      return;
    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };
  trapFocusHandlers.focusout = function() {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };
  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== "TAB")
      return;
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };
  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  elementToFocus.focus();
  if (elementToFocus.tagName === "INPUT" && ["search", "text", "email", "url"].includes(elementToFocus.type) && elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
};
window.toggleAttribute = function(element, key, value = "") {
  if (!element)
    return;
  if (element.hasAttribute(key)) {
    element.removeAttribute(key);
  } else {
    element.setAttribute(key, value);
  }
};
window.capitalizeEachWord = function(str) {
  const words = str.split(" ");
  const capitalizedWords = words.map((word) => {
    return word.charAt(0).toUpperCase() + word.slice(1);
  });
  return capitalizedWords.join(" ").replace(/([A-Z])/g, " $&").trim();
};
window.isElementInViewport = function(element) {
  const rect = element.getBoundingClientRect();
  return rect.top > 0 && rect.top < (window.innerHeight || document.documentElement.clientHeight);
};
window.isMobileDevice = function() {
  const isUserAgentMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const isScreenWidthMobile = window.innerWidth <= 768;
  return isUserAgentMobile || isScreenWidthMobile;
};
window.getProductTitleByOriginality = function(product) {
  const isOriginal = product.tags.includes("Original");
  let title = product.title;
  if (window.Shopify.identifyingProductOriginality && !isOriginal) {
    title = title.replace("Thesupermade", "").replace("The Supermade", "").replace("Supermade", "").trim();
  }
  return title;
};
window.setInnerHTML = function(element, html) {
  if (!element)
    return;
  element.innerHTML = html;
  element.querySelectorAll("script").forEach((oldScriptTag) => {
    const newScriptTag = document.createElement("script");
    Array.from(oldScriptTag.attributes).forEach((attribute) => {
      newScriptTag.setAttribute(attribute.name, attribute.value);
    });
    newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
    oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
  });
};
window.clearKlaviyoBodyScrollLock = function() {
  document.body.classList.remove("klaviyo-prevent-body-scrolling");
  document.body.style.removeProperty("overflow");
  document.documentElement.style.removeProperty("overflow");
};
document.addEventListener("klaviyoForms", function(event) {
  var _a;
  const eventType = (_a = event == null ? void 0 : event.detail) == null ? void 0 : _a.type;
  if (["close", "submit", "stepSubmit"].includes(eventType)) {
    window.clearKlaviyoBodyScrollLock();
  }
});
window.addEventListener("pageshow", function(event) {
  if (event.persisted) {
    window.clearKlaviyoBodyScrollLock();
  }
});
class CartInstance {
  _updateCart(callback) {
    var _a, _b, _c;
    const getSectionsToRender = [
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: "#cart-icon-bubble"
      },
      {
        id: "announcement-bar",
        section: (_a = document.getElementById("announcement-bar")) == null ? void 0 : _a.dataset.id,
        selector: ".shopify-section"
      }
    ];
    const cartDrawerElement = document.querySelector("cart-drawer");
    if (cartDrawerElement) {
      getSectionsToRender.push({
        id: "cart-drawer",
        section: "cart-drawer",
        selector: ".sm-drawer__container"
      });
    }
    const mainCartElement = document.querySelector("#main-cart");
    if (mainCartElement) {
      getSectionsToRender.push(
        {
          id: "main-cart-items",
          section: (_b = document.getElementById("main-cart-items")) == null ? void 0 : _b.dataset.id,
          selector: "#main-cart-items .js-contents"
        },
        {
          id: "main-cart-footer",
          section: (_c = document.getElementById("main-cart-footer")) == null ? void 0 : _c.dataset.id,
          selector: "#main-cart-footer .js-contents"
        }
      );
    }
    if (getSectionsToRender.length) {
      const sections = getSectionsToRender.reduce((acc, cur) => {
        return acc.length ? acc + "," + cur.section : cur.section;
      }, "");
      fetch(`${routes.cart_url}?sections=${sections}&_t=${Date.now()}`).then((response) => response.json()).then((sections2) => {
        getSectionsToRender.forEach((section) => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this._getSectionInnerHTML(sections2[section.section], section.selector);
        });
        callback && callback();
      });
    }
  }
  _getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }
}
document.addEventListener("DOMContentLoaded", function() {
  var _a;
  try {
    window.cartInstance = new CartInstance();
    const navigationEntry = performance.getEntriesByType("navigation")[0];
    if (navigationEntry) {
      if (navigationEntry.type === "back_forward") {
        (_a = window.cartInstance) == null ? void 0 : _a._updateCart();
      }
    }
  } catch (error) {
    console.error("Cart error occurred:", error);
  }
});
document.addEventListener('click', async function (e) {
  const swatch = e.target.closest('.sm-product-card__color-options-item');
  if (!swatch) return;

  const card = swatch.closest('product-card');
  if (!card) return;

  const colorName = swatch.dataset.color;
  const newSrc = swatch.dataset.src;

  // 1. 更新选中状态
  card.querySelectorAll('.sm-product-card__color-options-item').forEach(el => {
    el.classList.remove('is-active');
  });
  swatch.classList.add('is-active');

  // 2. 切换主图（直接用 data-src，无需再 fetch）
  if (newSrc) {
    const primaryImg = card.querySelector('.sm-card__media img');
    if (primaryImg) {
      primaryImg.src = newSrc;
    }
    // 如果用了 srcset，也可以更新 srcset
  }
}, true);

